import Component from "../../shared/component.abstract"

export default class Reload extends Component {
    constructor(private props: unknown, element: HTMLElement){
        super(props, element)
    }

     mounted(): void {

        this.element.addEventListener("click", (e) => {
            e.stopImmediatePropagation();
                // @ts-ignore
               document.forms["engine"].submit();  
        })
     }
}